import { memo } from 'react';

import { useEvent } from 'core/hooks';
import { Button, ButtonVariants, Window, WindowActionsBar } from 'core/ui';

type ConfirmUploadDiscardModalProps = {
  /** Callback for when the confirmation dialog is closed. */
  onClose: (cancelUpload: boolean) => void;
};

export const ConfirmUploadDiscardModal = memo<ConfirmUploadDiscardModalProps>(({ onClose }) => {
  const handleModalClose = useEvent(() => {
    onClose(false);
  });

  const handleAcceptClick = useEvent(() => {
    onClose(true);
  });

  return (
    <Window title="Abandon upload?" onClose={handleModalClose} initialWidth={400} modal>
      <p>Abandon current upload?</p>

      <WindowActionsBar>
        <Button variant={ButtonVariants.SECONDARY} onClick={handleModalClose}>
          Continue Upload
        </Button>

        <Button variant={ButtonVariants.PRIMARY} onClick={handleAcceptClick}>
          Abandon Upload
        </Button>
      </WindowActionsBar>
    </Window>
  );
});

ConfirmUploadDiscardModal.displayName = 'ConfirmUploadDiscardModal';
